const SET_CONFIRMATION_REQUEST = 'CONFIRMATIONS/SET_CONFIRMATION_REQUEST';
const RESOLVE_CONFIRMATION_REQUEST = 'CONFIRMATIONS/RESOLVE_CONFIRMATION_REQUEST';

export { SET_CONFIRMATION_REQUEST, RESOLVE_CONFIRMATION_REQUEST };
